"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Field;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        fieldCaption: {
            color: THEME.TextLight,
            fontSize: 12,
            marginBottom: 2,
        },
        fieldValue: {
            color: THEME.Text,
            fontSize: 14,
            marginTop: 2,
        },
    });
};
;
function Field(props) {
    const styles = useStyles();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { accessible: true, style: [{ paddingTop: 6, paddingBottom: 6 }, props.style], children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.fieldCaption, children: props.caption }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.fieldValue, children: props.value })] }));
}
;
